import React, { MouseEventHandler, SyntheticEvent } from 'react';
import { Box, BoxProps } from 'rebass';
import { CssTypeFix } from 'types/types';
import { To as RouterTo, useNavigate } from 'react-router';

export type OnClick = (e: SyntheticEvent) => void;
export type To = RouterTo;
export type ParentProps = Props;
export type Props = {
  children: React.ReactNode;
  // must define at least one of these
  onClick?: OnClick;
  to?: To;
  href?: string;
} & BoxProps &
  CssTypeFix;

export const CustomLink = ({
  children,
  onClick,
  to,
  href,
  ...restProps
}: Props) => {
  const navigate = useNavigate();

  if (href) {
    return (
      <a
        href={href}
        style={{
          textDecoration: 'none',
        }}>
        {children}
      </a>
    );
  }

  const actionProps: { onClick?: MouseEventHandler } = {};
  if (onClick) {
    actionProps.onClick = onClick;
  }
  if (to) {
    actionProps.onClick = () => navigate(to as RouterTo);
  }
  return (
    <Box {...restProps} {...actionProps}>
      {children}
    </Box>
  );
};
